export default {
    name: "numberInput",
    bind: function(el, binding, vnode) {
        function fillFunc(num, fill, length) {
            return (Array(length).join(fill) + num).slice(-length);
        }

        let { min, max, maxlength, fill } = binding.value;

        const ele = el.tagName === "INPUT" ? el : el.querySelector("input");

        el.dsHandler = function(el, ele, binding, vnode) {
            function handle() {
                let val = ele.value;
                if(binding.modifiers.float) {
                    val = val.replace(/[^\d.]/g, "");
                    // 只保留第一个, 清除多余的
                    val = val.replace(/\.{2,}/g, ".");
                    // 第一个字符如果是.号，则补充前缀0
                    val = val.replace(/^\./g, "0.");

                    if(typeof binding.value !== 'undefined') {
                        // 期望保留的最大小数位数
                        let pointKeep = 0;
                        if(typeof binding.value === 'string'
                          || typeof binding.value === 'number') {
                            pointKeep = parseInt(binding.value);
                        }else if(typeof binding.value === 'object') {
                            // 支持新的小数点保留位配置
                            pointKeep = binding.value.decimal;
                        }
                        if(!isNaN(pointKeep)) {
                            if(!Number.isInteger(pointKeep)
                           || pointKeep < 0) {
                                pointKeep = 0;
                            }
                            const str = '^(\\d+)\\.(\\d{' + pointKeep + '}).*$';
                            const reg = new RegExp(str);
                            if(pointKeep === 0) {
                                // 不需要小数点
                                val = val.replace(reg, '$1');
                            }else {
                                console.log('ddd', val, reg);
                                // 通过正则保留小数点后指定的位数
                                val = val.replace(reg, '$1.$2');
                            }
                        }
                    }
                }else {
                    // 只保留数字
                    val = ele.value.replace(/[^\d]/g, '');
                }
                if(val !== '' && typeof binding.value === 'object') {
                    min = parseFloat(min);
                    max = parseFloat(max);
                    maxlength = parseInt(maxlength);
                    fill = String(fill);
                    // 最小值
                    if(!isNaN(min)) {
                        if(min >= 0) {
                            // 不能是负数
                            val = val.replace('-', '');
                        }
                        if(parseFloat(val) < min) {
                            val = min;
                        }
                    }
                    // 最大值
                    if(!isNaN(max)) {
                        if(parseFloat(val) > max) {
                            val = max;
                        }
                    }
                    // 最大长度
                    if(!isNaN(maxlength)) {
                        if(parseFloat(val).toString().length > maxlength) {
                            // 长度过长截取
                            val = parseFloat(val.toString().substr(0, maxlength));
                        }
                    }
                }
                // console.log('numberInput', ele.value);
                ele.value = val;

                if(fill == null) {
                    if(vnode.componentInstance) {
                        vnode.componentInstance.$emit('input', ele.value);
                    }else {
                        vnode.elm.dispatchEvent(new CustomEvent('input', ele.value));
                    }
                }
            }

            return handle;
        };

        if(fill != null) {
            el.blurHandler = function(el, ele, binding, vnode) {
                function handle() {
                    let val = ele.value;
                    if(val !== '' && typeof binding.value === 'object') {
                        maxlength = parseInt(maxlength);
                        fill && (fill = String(fill));
                        // 长度不够补零
                        if(!isNaN(maxlength)) {
                            if(fill && parseFloat(val).toString().length < maxlength) {
                                val = fillFunc(val, fill, maxlength);
                            }
                        }
                    }
                    ele.value = val;

                    if(vnode.componentInstance) {
                        vnode.componentInstance.$emit('input', ele.value);
                    }else {
                        vnode.elm.dispatchEvent(new CustomEvent('input', ele.value));
                    }
                }

                return handle;
            };
            ele.addEventListener("blur", el.blurHandler(el, ele, binding, vnode));
        }
        ele.addEventListener("input", el.dsHandler(el, ele, binding, vnode));
    },
    unbind: function(el) {
        const ele = el.tagName === "INPUT" ? el : el.querySelector("input");
        ele.removeEventListener("input", el.dsHandler);
        ele.removeEventListener("blur", el.blurHandler);
    }
};
